<template>
    <div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="name" label="名称" min-width="100" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="图片">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.pic" :src="scope.row.pic" fit="contain" style="width:30px"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="奖品类型">
                    <template slot-scope="scope">
                        <p v-if="scope.row.type == 1">无</p>
                        <p v-else-if="scope.row.type == 2">优惠券</p>
                        <p v-else-if="scope.row.type == 3">普通奖品</p>
                        <p v-else>演出赠票</p>
                    </template>
                </el-table-column>
                <el-table-column prop="totalNum" label="发放总量">
                </el-table-column>
                <el-table-column prop="useNum" label="已发放">
                </el-table-column>
                <el-table-column prop="residueNum" label="剩余">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/lottery/prize/editStore')"
                            type="text"
                            size="small"
                            @click="edit(scope.row)"
                            >调整库存</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page-btns-box">
            <el-button @click="goBack()">返回</el-button>
        </div>

        <stock-edit ref="stockEdit" @onUpdate="getDataList"></stock-edit>
    </div>
</template>
<script>
import StockEdit from './components/stock-edit.vue'
export default {
     props:{
        id:{
            type: [String,Number],
            default: ''
        }
    },
    components:{StockEdit},
    data(){
        return{
            listLoading: true,
            dataList: [],
            redirect: this.$route.query.redirect,
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/lottery/prize/lotteryPrizeList",
                method: "POST",
                params: {
                    lotteryActivityId: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.dataList = result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        edit(data){
            this.$refs.stockEdit.show({
                lotteryActivityId: this.id,
                lotteryPrizeId: data.id,
                residueNum:data.residueNum
            })
        }
    },
}
</script>
